module.exports = __webpack_public_path__ + "static/img/img_cz_pt_sy.308fab93.png";